import type { PlanRepository } from '../repositories/plan-repository';

export class DeletePlanUseCase {
  constructor(private readonly repository: PlanRepository) {}

  async execute(id: string): Promise<void> {
    return this.repository.delete(id);
  }
}
